export enum CHANGE_VIEW_TYPES {
  MODAL = 'modal',
  ROUTE = 'route',
  TABS = 'tabs',
  TREE = 'tree',
  ONBOARDING_VERIFICATION_PAGE = 'onboarding_verification_page',
}

// Actions
export enum ActionType {
  SET_CHANGE_VIEW_HANDLER = 'view/SET_CHANGE_VIEW_HANDLER',
  REMOVE_CHANGE_VIEW_HANDLER = 'view/REMOVE_CHANGE_VIEW_HANDLER',
  CLEAN_UP = 'view/CLEAN_UP',
}

// Action creators

// This action has to be called to trigger change view handler
// Example of usage:
// Trigger view change handler before navigation to some page
// dispatch(changeView(() => navigate("/accounts/account-summary"))
export const changeView =
  (callback: () => void, type: CHANGE_VIEW_TYPES = CHANGE_VIEW_TYPES.ROUTE) =>
  async (dispatch: any, getState: any) => {
    const { handler } = getState().view;
    if (handler) {
      handler(async () => {
        dispatch(removeChangeViewHandler());
        await callback();
      }, type);
    } else {
      await callback();
    }
  };

// Set handler function that will be called before changing the view
// Handler has one argument to trigger view change, when all confirm actions were done
export const setChangeViewHandler =
  (handler: (resolve?: () => void, type?: CHANGE_VIEW_TYPES) => void) =>
  async (dispatch: any) => {
    dispatch({
      type: ActionType.SET_CHANGE_VIEW_HANDLER,
      payload: handler,
      key: 'handler',
    });
  };

export const removeChangeViewHandler = () => (dispatch: any) => {
  dispatch({
    type: ActionType.SET_CHANGE_VIEW_HANDLER,
    payload: null,
    key: 'handler',
  });
};

export const cleanUpViewReducer = () => ({
  type: ActionType.CLEAN_UP,
  payload: null,
});
